import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareSessionsRoute: InvariantJiraRoute = {
	name: 'software-sessions',
	exact: true,
	path: '/jira/software/projects/:projectKey/sessions',
};
